<template>
  <div class="form-field-wrap">
    <div class="border--1px border--solid border--gray border--lighten-3">
      <div class="form-upload inline-block">
        <input
          type="file"
          class="form-upload__input"
          @change="handleFileAdd($event)"
          :ref="name"
          :accept="acceptStr"
        >
        <label class="btn btn--md pl--20px border-r--1px border--solid border--gray border--lighten-3 gray lighten-5">
          <span class="lh--20px text--middle text--gray text--lighten-1 font--18px btn-icon">
            <i class="material-icons">
              attach_file
            </i>
          </span>
          파일업로드
        </label>
      </div>

      <span class="position--relative">
        <span class="font--14px text--gray text--darken-2 mx--16px">{{files.length === index ? uploadStatus : files[index].originalName}}</span>
        <form-button
          v-if="files.length !== index"
          class="icon--btn btn--md position--absolute -top--9px right--0px -mr--24px text--gray"
          icon="highlight_off"
          @click="$emit('removeFile', index)"
        ></form-button>
      </span>
    </div>

    <form-error
      :error="error"
      :name="name"
    ></form-error>
    <help-text :label="helpText"></help-text>
  </div>
</template>

<script>
import focusOnError from '@/component/ui/focusOnError'

export default {
  mixins: [focusOnError],
  props: {
    index: { type: Number },
    error: { type: Object, required: true },
    url: { type: String, required: true },
    uuid: { type: String, required: true },
    files: { type: Array, required: true },
    limit: { type: Number, default: 1 },
    required: { type: Boolean, default: false },
    extraClass: { type: String, default: '' },
    helpText: { type: String, default: '' },
    uploadStatus: { type: String, default: '' },
    accept: { type: Array }
  },
  computed: {
    requiredClass () {
      return this.required ? 'is-essential' : ''
    },
    acceptStr () {
      if (this.accept) {
        return this.accept.join(', ')
      }
      return ''
    }
  },
  methods: {
    async fileUpload (file, config) {
      var formData = new FormData()
      formData.append('file', file)
      const url = `${this.url}${this.uuid}`
      const res = await this.$http.post(url, formData, config)
      console.log('res', res)
      return res
    },
    async handleFileAdd (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }

      this.$emit('error', {})
      this.$emit('fileUpload', '')

      const config = {
        onUploadProgress: progressEvent => {
          this.$emit('fileUpload', `업로드 중: ${Math.round((progressEvent.loaded * 100) / progressEvent.total)}%`)
        }
      }

      try {
        // this.files = [{
        //   originalName: ''
        // }]
        const { data } = await this.fileUpload(files[0], config)
        // this.files = []
        const file = {
          originalName: data.originalName,
          fileName: data.fileName,
          fileSize: data.fileSize,
          fileExt: data.fileExt,
          uuid: data.uuid
          // cancelToken
        }
        if (this.files.length === this.index) {
          this.files.push(file)
        } else {
          this.$set(this.files, this.index, file)
        }
      } catch (ex) {
        // console.error(ex, ex.response)
        if (ex.response) {
          const { fieldId, errorMessage } = ex.response.data
          const error = { fieldId, errorMessage }
          this.$emit('error', error)
        }
        // this.$emit('fileUpload', ``)
        console.error(ex, ex.response)
      }
      this.$emit('fileUpload', ``)
    }
  },
  components: {
    FormButton: () => import('@/component/ui2/button/FormButton'),
    FormError: () => import('@/component/ui2/form/FormError'),
    HelpText: () => import('@/component/ui2/common/HelpText')
  }
}
</script>
